import React, { useEffect, useState } from "react";
import Navbar from "../navBar";

function VotingPageShell({ children, className = "" }) {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 1024
  );
  const [isCollapsed, setIsCollapsed] = useState(
    () => typeof window !== "undefined" && window.localStorage.getItem("desac-sidebar-collapsed") === "true"
  );

  useEffect(() => {
    const updateViewport = () => {
      setIsDesktop(window.innerWidth >= 1024);
      setIsCollapsed(window.localStorage.getItem("desac-sidebar-collapsed") === "true");
    };
    const updateCollapsed = (event) => {
      setIsCollapsed(
        typeof event?.detail?.collapsed === "boolean"
          ? event.detail.collapsed
          : window.localStorage.getItem("desac-sidebar-collapsed") === "true"
      );
    };

    window.addEventListener("resize", updateViewport);
    window.addEventListener("storage", updateCollapsed);
    window.addEventListener("desac-sidebar-toggle", updateCollapsed);
    return () => {
      window.removeEventListener("resize", updateViewport);
      window.removeEventListener("storage", updateCollapsed);
      window.removeEventListener("desac-sidebar-toggle", updateCollapsed);
    };
  }, []);

  const sidebarWidth = isDesktop && isCollapsed ? "5rem" : "16rem";

  return (
    <>
      <Navbar />
      <main
        style={{ "--voting-sidebar-width": sidebarWidth }}
        className={`min-h-screen min-w-0 overflow-x-hidden bg-surface-950 pt-16 text-white transition-[margin] duration-200 md:ml-64 md:pt-0 lg:ml-[var(--voting-sidebar-width)] ${className}`}
      >
        {children}
      </main>
    </>
  );
}

export default VotingPageShell;
